import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDollarSign, FiShare2, FiSearch, FiTrendingUp, FiBarChart2 } = FiIcons;

const Expansion = () => {
  const addons = [
    {
      title: 'Paid Ads Optimization System',
      desc: 'Workflows for managing Google & Meta ads, including budget pacing and creative refresh cycles.',
      icon: FiDollarSign,
      color: 'bg-blue-500'
    },
    {
      title: 'Social Content Automation',
      desc: 'System to batch-create, approve, and schedule social posts across LinkedIn, Twitter, and IG.',
      icon: FiShare2,
      color: 'bg-pink-500'
    },
    {
      title: 'SEO Expansion Kit',
      desc: 'Advanced keyword tracking, backlink monitoring workflows, and technical audit schedules.',
      icon: FiSearch,
      color: 'bg-emerald-500'
    },
    {
      title: 'CRO Playbook',
      desc: 'Conversion Rate Optimization testing framework, hypothesis logs, and experiment result tracking.',
      icon: FiTrendingUp,
      color: 'bg-orange-500'
    },
    {
      title: 'Monthly Reporting-as-a-Service',
      desc: 'We handle the data extraction and slide deck creation for your monthly executive reviews.',
      icon: FiBarChart2,
      color: 'bg-purple-500'
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-8"
      >
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Expansion Opportunities</h1>
        <p className="text-lg text-gray-600">
          Once the foundation is set, activate these modules to drive deeper growth and efficiency.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {addons.map((addon, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.1 }}
            className="glass-card rounded-xl p-6 hover:shadow-lg transition-all cursor-pointer group"
          >
            <div className={`w-12 h-12 ${addon.color} rounded-xl flex items-center justify-center mb-4 shadow-md group-hover:scale-110 transition-transform`}>
              <SafeIcon icon={addon.icon} className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">{addon.title}</h3>
            <p className="text-gray-600 text-sm leading-relaxed">{addon.desc}</p>
            <div className="mt-4 pt-4 border-t border-gray-100 flex justify-end">
              <span className="text-emerald-600 font-medium text-sm group-hover:translate-x-1 transition-transform">
                Learn more &rarr;
              </span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Expansion;